import * as React from 'react';
import { IcommonProps } from './common/props';
import { Card, Row, Col, Button, Breadcrumb, Modal, Icon, Dropdown, Menu, message } from 'antd';
import Util from './common/utils';
import Print from './common/print';
import Export from './common/export';
import OrganizationList  from './organization/OrganizationList';
import OrganizationFilter  from './organization/OrganizationFilter';
import OrganizationAddEdit  from './organization/OrganizationAddEdit';
import '../css/Organization.scss';
// import { historyNotifier } from './common/historyNotifier';
import { Route } from 'react-router-dom';
import service from '../service/apolloclient.service';
import Comparator from './common/comparer';
import { MSGDISPLAYTIME } from './common/constants';
import { Link } from 'react-router-dom';
import { STATICKEYS, staticProperties } from './common/staticProperties';
import { VIEWSTATE } from './common/constants';
import OrganizationBulkUpload from './organization/OrganizationBulkUpload';
import LocalStorage from '../service/localstorage';
import strings from '../eyeguide-localization/organization/strings.organization';
import ViewOrganization from './organization/ViewOrganization';
import Auth from './common/auth';
import { Tasks } from './common/auth';
import Token from './common/token';

const storage = new LocalStorage();

const VIEWS = {
    ORGLIST: 'list',
    ADDORG: '/organization/add',
    EDITORG: '/organization/edit/',
    BULKUPLOAD: '/organization/upload',
    VIEWORG: '/organization/view/'
};

const LISTDROPDOWNTEXT = {
    0: strings.lsInactiveOrgTxt,
    1: strings.lsActiveOrgTxt,
    2: strings.lsAllOrgTxt
};

interface IoganizationsProps extends IcommonProps {
    navigateFrom: any;
    notifyOrgStatusChange: any;
    match: any;
    location: any;
}

interface IrosterState {
    origOrgs: any;
    orgs: any;
    error: boolean;
    view: string;
    orgAddEditTitle: string;
    breadCrumbValue: string;
    orgToEdit: any;
    orgToView: any;
    modalVisible: boolean;
    filterObj: any;
    prevFilterObj: any;
    showOrgList: any;
    printModalVisible: boolean;
    exportModalVisisble: boolean;
    printTestOpt: number;
    navigationFrom: number;
    userBtnText: string;
    listActiveBit: number;
    loading: boolean;
    emptyText: string;
    isFocusUser: boolean;
}

export default class Organizations extends React.Component<IoganizationsProps, IrosterState> {
    iframe: HTMLIFrameElement | null;

    menu = (
        <Menu onClick={() => this.exportFile()}>
          <Menu.Item key="1">{strings.lsCSVTxt}</Menu.Item>
        </Menu>
    );

    constructor(props: IoganizationsProps) {
        super(props);
        let roleid: number = parseInt(Token.decodeToken().roleid, 10);
        this.state = {
            origOrgs: [],
            error : false,
            orgs: [],
            view: VIEWS.ORGLIST,
            orgAddEditTitle: strings.lsManageOrgTxt,
            breadCrumbValue: strings.lsOrgsTxt,
            orgToEdit: '',
            modalVisible: false,
            filterObj: [],
            prevFilterObj: [],
            orgToView: '',
            showOrgList: true,
            printModalVisible: false,
            exportModalVisisble: false,
            printTestOpt: 0,
            navigationFrom: 0,
            userBtnText: LISTDROPDOWNTEXT['1'],
            listActiveBit: 1,
            loading: true,
            emptyText: '',
            isFocusUser: Auth.canPerformTask(roleid, Tasks.isFocusUser),
          };
        this.changeFilter = this.changeFilter.bind(this);
        this.handleOrgActivation = this.handleOrgActivation.bind(this);
        this.notifyOrgStatusChange = this.notifyOrgStatusChange.bind(this);
        // historyNotifier.addEventListener('Organization', this.getCompState, this.setCompState);
        
    }

    componentDidMount() {
        strings.setLanguage(navigator.language);
        Util.resetScroll();
        if (!this.ifRouteExists(this.props)) {
            staticProperties.set(STATICKEYS.selectedKey, VIEWSTATE.ORGANIZATION);
            staticProperties.set(STATICKEYS.selectedRoster, '');
            this.intializeOrgList(this.state.listActiveBit);
        }
     }
 
    componentWillReceiveProps(nextProps: any) {
        Util.resetScroll();
        if (!this.ifRouteExists(nextProps)) {
            staticProperties.set(STATICKEYS.selectedKey, VIEWSTATE.ORGANIZATION);
            staticProperties.set(STATICKEYS.selectedRoster, '');
            this.intializeOrgList(this.state.listActiveBit);
            this.setState({view: VIEWS.ORGLIST,                      
                breadCrumbValue: strings.lsManageOrgTxt, 
                orgAddEditTitle: strings.lsManageOrgTxt, 
                orgToEdit: '',
            });
        }
    }

    render() {
        if (this.state.isFocusUser && storage.getSelectedOrg() === '' && !this.isViewRoute(this.props)) {
            history.forward();
            return <div/>;
        } else {
        return (
            <div>
            <Route
                path={VIEWS.EDITORG + ':orgid'} 
                render={(props: any) => 
                    <OrganizationAddEdit
                        save=""
                        cancel=""
                        organizationName={this.props.organizationName}
                        enableTitleSpace={this.props.enableTitleSpace}
                        organizationID={this.props.organizationID} 
                        rosterID=""
                        navigationFrom={this.state.navigationFrom}
                        notifyOrgStatusChange={this.notifyOrgStatusChange}
                        {...props}
                    />                 
                }
            />
            <Route
                path={VIEWS.ADDORG} 
                render={(props: any) => 
                    <OrganizationAddEdit
                        save=""
                        cancel=""
                        organizationName={this.props.organizationName}
                        enableTitleSpace={this.props.enableTitleSpace}
                        organizationID={this.props.organizationID} 
                        rosterID=""
                        navigationFrom={this.state.navigationFrom}
                        notifyOrgStatusChange={this.notifyOrgStatusChange}
                        {...props}
                    />                 
                }
            />
            <Route
                path={VIEWS.BULKUPLOAD} 
                render={(props: any) => 
                    <OrganizationBulkUpload
                        notifyOrgStatusChange={this.notifyOrgStatusChange}
                        {...props}
                    />
                }
            />
            <Route
                path={VIEWS.VIEWORG + ':orgData'}
                render={(props: any) => 
                    <ViewOrganization
                        {...props}
                    />
                }
            />
             {   
            this.ifRouteExists(this.props) ? '' :
            <div id="Organization" className="Organization">
            <Card >
                <Breadcrumb>
                    <Breadcrumb.Item><a href="/dashboard">{strings.lsHomeTxt}</a></Breadcrumb.Item>
                    <Breadcrumb.Item>{strings.lsOrgsTxt}</Breadcrumb.Item>
                </Breadcrumb>
                 <br/>
                <h3>{this.state.orgAddEditTitle} </h3>
            </Card>
            <div className="contentWithoutTitle">
                <Card className="filterCard">
                    <span 
                        className="filterIcon"
                        onClick={e => {
                            console.log('clicked');
                            this.setState({
                                modalVisible: true
                            });
                         }}
                    >
                    <Icon 
                        type="filter" 
                        style={{fontSize: 19, float: 'right'}}
                    />
                    </span>
                    <span style={{'fontSize': '14px', 'fontWeight': 'normal'}}>
                       <span hidden={this.checkIfFilterExists('', true)}>
                            {strings.lsNoFilterTxt}
                        </span>
                        <div className="filterContent" hidden={!this.checkIfFilterExists('', true)}>
                            <Button 
                                className="clearFilter" 
                                onClick={e => {
                                    this.clearFilters();
                                }}
                            >
                                {strings.lsClearFilterTxt}
                            </Button>
                            <Row className="filterRow" hidden={this.checkIfFilterExists('name')}>
                                <Col span={7}>{strings.lsNameTxt}:</Col> 
                                <Col span={15}> {this.getFilterValues('name')} </Col>
                            </Row>
                            <Row className="filterRow" hidden={this.checkIfFilterExists('contactfirstname')}>
                                <Col span={7}>{strings.lsContactFirstNameTxt}:</Col>
                                <Col span={15}>{this.getFilterValues('contactfirstname')}</Col>
                            </Row>
                            <Row className="filterRow" hidden={this.checkIfFilterExists('contactlastname')}>
                                <Col span={7}>{strings.lsContactLastNameTxt}:</Col>
                                <Col span={15}>{this.getFilterValues('contactlastname')}</Col>
                            </Row>
                            <Row className="filterRow" hidden={this.checkIfFilterExists('contactphone')}>
                                <Col span={7}>{strings.lsContactPhoneTxt}:</Col>
                                <Col span={15}>{this.getFilterValues('contactphone')} </Col>
                            </Row>
                            <Row className="filterRow" hidden={this.checkIfFilterExists('contactemail')}>
                                <Col span={7}>{strings.lsContactEmailTxt}:</Col>
                                <Col span={15}>{this.getFilterValues('contactemail')}</Col>
                            </Row>
                        </div>
                    </span>

                </Card>                   
                <Card 
                    title={strings.lsManageOrgTxt}
                    bordered={false}
                    className="card"
                >
                    <Link
                        to={'/organization/add'}
                    >
                        <Button         
                            type="primary" 
                            icon="plus-circle-o"
                            onClick={e => { 
                                this.setState({ view: VIEWS.ADDORG,  orgAddEditTitle: 'Add Organization', 
                                breadCrumbValue: 'Add', showOrgList: false});
                                this.props.enableTitleSpace(true);

                            }}
                        >{strings.lsAddOrgTxt}
                        </Button>   
                    </Link>
                    <Link 
                        style={{color: 'white', paddingLeft: '5px'}}
                        to={VIEWS.BULKUPLOAD}
                    >
                        <Button         
                            type="primary" 
                            icon="upload"
                        >
                            {strings.lsUploadOrgTxt}
                        </Button>
                    </Link> 
                    <Dropdown 
                        trigger={['click']}
                        overlay={this.menu}
                        getPopupContainer={this.getContainer}
                    ><Button className="downloadBtn"> 
                        {strings.lsDwnldTxt} <Icon type="down" style={{ fontSize: 10}}/> </Button>
                    </Dropdown>
                    <Modal
                        title={strings.lsExportOrgTxt}
                        visible={this.state.exportModalVisisble}
                        onOk={() => this.setState({exportModalVisisble: false})}
                        okText={strings.lsOkTxt}
                        width={450}
                        bodyStyle={{padding: 0 }}
                        maskClosable={false}
                        closable={false}
                        footer={[
                            <Button 
                                    key="Ok" 
                                    type="primary"  
                                    onClick={() => this.setState({exportModalVisisble: false})}
                            >
                            {strings.lsOkTxt}
                            </Button>,
                        ]}
                    >
                    <Row style={{padding: '19px'}}>
                        {strings.lsExportOrgSuccessTxt}
                    </Row>
                    </Modal>
                    <Button 
                        style={{marginLeft: 10, marginBottom: 20, float: 'right'}}
                        onClick={() => this.printList()}
                    >{strings.lsPrintTxt}
                    </Button>           
                    <iframe 
                        style={{height: 0, width: 0, border: 'none'}} 
                        ref={el => this.iframe = el} 
                    /> 
                    <Dropdown 
                        trigger={['click']}
                        overlay={
                            <Menu  onClick={(e: any) => this.changeListDisplay(e)}>
                                <Menu.Item key="0">
                                {LISTDROPDOWNTEXT['0']}
                                {this.state.listActiveBit === 0 ?
                                    <Icon 
                                        type="check" 
                                        style={{ fontSize: 16, color: 'green', paddingLeft: '3px'}}
                                    />
                                                : ''}
                                </Menu.Item>
                                <Menu.Item key="1">{LISTDROPDOWNTEXT['1']}
                                {this.state.listActiveBit === 1 ?
                                    <Icon 
                                        type="check" 
                                        style={{ fontSize: 16, color: 'green', paddingLeft: '3px'}} 
                                    /> 
                                                : ''}
                                </Menu.Item>
                                <Menu.Item key="2">{LISTDROPDOWNTEXT['2']}
                                {this.state.listActiveBit === 2 ?
                                    <Icon 
                                        type="check" 
                                        style={{ fontSize: 16, color: 'green', paddingLeft: '3px'}} 
                                    /> 
                                                : ''}
                                </Menu.Item>
                            </Menu>}
                          
                        getPopupContainer={this.getContainer}
                    >   
                        <Button className="downloadBtn"> 
                            {this.state.userBtnText} 
                            <Icon type="down" style={{ fontSize: 10, paddingRight: '7px'}}/> 
                        </Button>
                    </Dropdown>
                    <OrganizationList
                        organizationID={this.props.organizationID} 
                        rosterID={this.props.rosterID} 
                        organizationName={this.props.organizationName}
                        enableTitleSpace={this.props.enableTitleSpace}
                        orgs={this.state.orgs}
                        notifyActiveClick={this.handleOrgActivation}
                        loading={this.state.loading}
                        emptyText={this.state.emptyText}
                        isCustomer={false}
                    />                      
                </Card>
            </div>
            <Modal 
                className="modal"
                title={strings.lsOrgFilterTxt}
                visible={this.state.modalVisible}
                okText={strings.lsFilterTxt}
                onOk={() => this.setModalVisible(1)}
                onCancel={() => this.setModalVisible(0)}
                width={1000}
                bodyStyle={{padding: 0 }}
                maskClosable={false}
                closable={false}
                destroyOnClose={true}
            >   
                <OrganizationFilter 
                    filterObj={this.state.filterObj}
                    notifyChangeFilter={this.changeFilter}
                />                       
            </Modal>

            </div>
             }
        </div>
        );
    }
    }

    /**
     * Fetches the list of organizations from server
     */
    private async  intializeOrgList(activeBit: number = 0) {
        let orgs: any = [];
        let ser = new service();
        orgs = await ser.getSubOrganizations(activeBit, storage.getSelectedOrgPrimary());
        console.log('orgs', orgs);
        if (orgs.length > 0) {
        orgs = this.sortOrganizations(orgs);
        }
        this.setState({
            origOrgs : orgs,
            orgs: orgs,
            loading: false,
            emptyText: orgs.length === 0 ? 'No data' : ''
        });
        this.filterList();
    }
    
    private sortOrganizations(subOrgs: any) {
        console.log('this.state.organizations', subOrgs); 
        let orgs: any = [...subOrgs];
        let primeIndex: number = 0;
        let primeOrg = subOrgs.filter((e: any, index: number) => {
            if (e.isprimary === true) {
              primeIndex = index;
              return true;
            } else {
              return false;
            }
  
        });
        // let a = [];
        // a.unshift()
        if (primeOrg.length > 0) {
            console.log('organization to beeee');
            orgs.splice(primeIndex, 1);
            console.log('organization spliced ', orgs);
            orgs.unshift(primeOrg[0]);
            console.log('organization unshift ', orgs);
        }
        return orgs;
    }
    
    /**
     * Checks if any filter exists or for a particular property
     * @param property Filter property
     * @param chkIfFiltered If true, checks if any filter exists at all. 
     * If false, property is checked for existence
     */
    private checkIfFilterExists(property: string, chkIfFiltered: boolean = false): boolean {
        if (chkIfFiltered) {
            console.log('isObjectEmpty', Util.isObjectEmpty(this.state.filterObj));
            return Util.isObjectEmpty(this.state.filterObj) === true ? false : true;
        } else if (Util.isObjectEmpty(this.state.filterObj) === false) {
            console.log('isObjectEmptyElse', Util.isObjectEmpty(this.state.filterObj));
            let value = this.getFilterValues(property);
            if (value === '' || value === undefined) { return true; } else { return false; }
        } else {
            return true;
        }
    }

    /**
     * Builds print data and calls export util
     */
    private async printList() {
        console.log('OrgsFromPrint', this.state.orgs);
        let buildData: any;
        buildData = this.buildOrgData(this.state.orgs);
        console.log('buildData', buildData);
        if (buildData.length > 0) {
            Print.printContents(buildData, strings.lsOrgsTxt, this.iframe);
        }
    }

    /**
     * Clears filter array which is used fo displaying and filtering data
     */
    private clearFilters() {
        this.intializeOrgList(this.state.listActiveBit);
        this.setState({
            filterObj: [],
            prevFilterObj: []
        });
    }

    /**
     * Builds export data and calls export util
     */
    private async exportFile() {
        console.log('orgsForPrint', this.state.orgs);
        let buildData: any;
        buildData = this.buildOrgData(this.state.orgs);
        if (buildData.length > 0) {
            Export.exportCSVFile(buildData, strings.lsOrgsTxt);
            this.setState({exportModalVisisble: true});
        }
    }

    /**
     * Gets the value of property for which filter is applied
     * @param key Property for which filter is to be applied
     */
    private getFilterValues(key: string): string {
       return this.state.prevFilterObj[key];  
    }

    /**
     * Closes the filter modal and performs tasks as per the event
     * @param event Cancel/ Filter click
     */
    private setModalVisible(event: number) {
        if (event === 1) {// filter click
             this.filterList();
        } else { // cancel click
            this.setState({filterObj: {...this.state.prevFilterObj}});
        }
        this.setState({
            modalVisible: false,
        });
    }

    /**
     * Filters the list using the filter object created
     */
    private filterList() {
        console.log('filterObj', this.state.filterObj);
        console.log('orgslist', this.state.origOrgs);
        let filterObject = this.state.filterObj;
        let filteredOrgs = this.state.origOrgs.filter(function(obj: any[]) {
            let matched = false;   
            let comp: Comparator;
            comp = new Comparator();
            matched = comp.compare(filterObject, obj);
            // console.log('comparator', matched);
            if (matched) {
                return true;
            } else {
                return false;
            }
        });
        console.log('filteredOrgs', filteredOrgs);
        this.setState({orgs: filteredOrgs, prevFilterObj: {...this.state.filterObj},
            emptyText: filteredOrgs.length === 0 ? 'No data' : ''});
    }

    /**
     * This function builds the data required by the Table component to display the orgs
     * @param orgs Organization array containing the orgs to be dispalyed
     */
    private buildOrgData(orgs: Array<any>) {
        let columnData: Array<any> = [];
        orgs.forEach( (element: any) => {
            let data: any = {};
            data.name = element.name;
            data.contact_first_name = element.contactfirstname === null ? '' : element.contactfirstname;
            data.contact_last_name = element.contactlastname === null ? '' : element.contactlastname;
            data.contact_phone = element.contactphone === null ? '' : element.contactphone; 
            data.contact_email = element.contactemail === null ? '' : element.contactemail;
            columnData.push(data);
        }); 
        return columnData;
    }

    /**
     * Assigns filters set through filter component
     * @param filterObj Filter Object sent by filter component
     */
    private async changeFilter(filterObj: any) {
        console.log('changeFilter', filterObj);
        this.setState({ filterObj: filterObj });
    }

    /**
     * sets the container element for dropdown menu
     */
    private getContainer = (triggernode) => {
        console.log('getContainer org', triggernode.parentNode);
        return triggernode.parentNode;
    }

    /**
     * Changes organization activation as per the active bit.
     * @param activeBit Active/InActive bit to set to the org. 0 - Inactive, 1 - Active
     * @param orgId Organization id.
     */
    private async handleOrgActivation(activeBit: number, orgId: string, record: any) {
        console.log('handleOrgActivation', storage.getSelectedOrgName());
        let orgObj: any = {
            active : activeBit,
            name : record.name,
            customer: storage.getSelectedOrgName()
        };
        let ser = new service();
        let orgResponse: any = await ser.updateSubOrganization(orgObj, orgId);
        console.log(orgResponse);
        let msgTerm: string = activeBit === 0 ? strings.lsDeactivatedTxt : strings.lsActivatedTxt;
        message.success(strings.formatString(strings.lsOrgSuccessMsgTxt, msgTerm), MSGDISPLAYTIME);   
        this.intializeOrgList(this.state.listActiveBit); 
        this.props.notifyOrgStatusChange(); // refresh side pane of main
    }

    /**
     * Handles the change of organization list when toggled between active/inactive/all
     * @param menuObj Menu Object that is clicked
     */
    private changeListDisplay(menuObj: any) {
        console.log('changeList', menuObj);
        let itemClicked: string = menuObj.key;
        this.setState({
            userBtnText: LISTDROPDOWNTEXT[menuObj.key],  
            listActiveBit:  parseInt(itemClicked, 10),
            loading: true
         });
        this.intializeOrgList(parseInt(itemClicked, 10));
    }

    /**
     * Checks the URL hit for other internal URL s
     * @param props Component Props
     */
    private ifRouteExists(props: any) {
        let exists = false;
        [VIEWS.ADDORG, VIEWS.EDITORG, VIEWS.BULKUPLOAD, VIEWS.VIEWORG].forEach((e: string) => {
            exists = props.location.pathname.startsWith(e) || exists;
        });
        return exists;
    }   
    
    private isViewRoute(props: any) {
        let exists = false;
        [VIEWS.VIEWORG].forEach((e: string) => {
            exists = props.location.pathname.startsWith(e) || exists;
        });
        return exists;
    }
    
    /**
     * Notifies Main component to refresh side panel that lists orgs
     */
    private notifyOrgStatusChange() {
        this.props.notifyOrgStatusChange();
    }
}


// WEBPACK FOOTER //
// ./src/components/Organizations.tsx